export default defineNuxtPlugin((nuxtApp) => {
  const { cookiesEnabledIds } = useCookieControl();
  const { initialize, enableAnalytics } = useGtag();

  if (cookiesEnabledIds.value?.includes("google-analytics")) {
    initialize();
    enableAnalytics();
  }
});
